import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSheetStatus } from "../events/helpers";
import { format } from "date-fns";

const useScheduleEventCardData = (event) => {
  const workersData = useSelector((state) => state.schedule.resources.workers);

  const { sheet, project, originalStart, originalEnd, equipment: sheetEquipment, workers: sheetWorkers } =
    event?.extendedProps || {};

  const data = useMemo(() => {
    if (!sheet) {
      return {
        jobNumber: '',
        contractor: '',
        statusText: '',
        status: '',
        timeRange: '',
      };
    }

    const jobNumber = project?.jobNumber;
    const contractor = project?.contractor?.nickname || project?.contractor?.name;

    // status text
    const { statusText, status } = getSheetStatus(sheet);

    // time range
    let timeRange = '';
    if (originalStart && originalEnd) {
      try {
        const start = new Date(originalStart);
        const end = new Date(originalEnd);
        timeRange = `${format(start, 'p')} - ${format(end, 'p')}`;
      } catch {
        timeRange = '';
      }
    }

    // resources
    const workers = sheetWorkers?.filter(Boolean) || [];
    const equipment = sheetEquipment?.map((e) => ({
      id: e._id,
      name: e.name,
      color: e.color,
      number: e.number,
    })).filter(Boolean) || [];

    return { jobNumber, contractor, statusText, status, timeRange, workers, equipment };
  }, [sheet, project, originalStart, originalEnd, sheetEquipment, workersData]);

  return data;
}

export default useScheduleEventCardData;